import type { CSSProperties } from "react";
import { noteForIndex, triggerMomentary, type InstrumentPlayerProps } from "../playerTypes";

export function GayageumPlayer(props: InstrumentPlayerProps) {
  const stringCount = Math.max(12, props.variant.stringProfile?.stringCount ?? 12);
  const compact = stringCount > 16;

  return (
    <div className="instrument-ui gayageum-ui" data-testid="instrument-player-gayageum">
      <div className="gayageum-zones">
        <section
          className="gesture-zone nonghyeon-zone"
          aria-label="Left-hand nonghyeon area"
          data-control-target="gayageum-nonghyeon"
          onPointerMove={(event) => {
            const box = event.currentTarget.getBoundingClientRect();
            props.onControl("nonghyeon_depth", 1 - (event.clientY - box.top) / box.height);
          }}
        >
          <span>Left-hand nonghyeon</span>
          <button type="button" aria-label="Gayageum nonghyeon" onClick={() => triggerMomentary(props, "G4", "nonghyeon", 0.76, 520)}>
            Nonghyeon
          </button>
          <button type="button" aria-label="Gayageum jeonseong quick roll" onClick={() => triggerMomentary(props, "D4", "jeonseong", 0.82, 240)}>
            Jeonseong quick roll
          </button>
          <label className="surface-slider">
            <span>Nonghyeon depth</span>
            <input
              aria-label="Gayageum nonghyeon depth"
              type="range"
              min="0"
              max="1"
              step="0.01"
              defaultValue="0.5"
              onInput={(event) => props.onControl("nonghyeon_depth", Number(event.currentTarget.value))}
            />
          </label>
        </section>
        <section className="gesture-zone pluck-zone" aria-label="Right-hand plucking area" data-control-target="gayageum-pluck">
          <span>Right-hand pluck</span>
          <button type="button" aria-label="Gayageum toeseong release fall" onClick={() => triggerMomentary(props, "E4", "toeseong", 0.78, 520)}>
            Toeseong release/fall
          </button>
        </section>
      </div>
      <div className={`gayageum-strings ${compact ? "is-compact" : ""}`} aria-label={`${stringCount} gayageum strings`}>
        {Array.from({ length: stringCount }, (_, index) => {
          const noteName = noteForIndex(props.instrument.playableNotes, index);
          const active = props.activeNotes.includes(noteName);

          return (
            <button
              key={`${props.variant.id}-${index}`}
              type="button"
              className={`gayageum-string ${active ? "is-active" : ""}`}
              aria-label={`Play gayageum string ${index + 1}`}
              aria-pressed={active}
              data-testid={`gayageum-string-${index}`}
              style={{ "--string-index": index } as CSSProperties}
              onPointerDown={() =>
                props.onNoteStart({ source: "pointer", noteName, velocity: 0.48 + index / stringCount / 2 })
              }
              onPointerUp={() => props.onNoteEnd(noteName)}
              onPointerCancel={() => props.onNoteEnd(noteName)}
              onTouchStart={() =>
                props.onNoteStart({ source: "pointer", noteName, velocity: 0.48 + index / stringCount / 2 })
              }
              onTouchEnd={() => props.onNoteEnd(noteName)}
              onKeyDown={(event) => {
                if (!event.repeat && (event.key === "Enter" || event.key === " ")) {
                  props.onNoteStart({ source: "keyboard", noteName, velocity: 0.56 + index / stringCount / 2 });
                }
              }}
              onKeyUp={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  props.onNoteEnd(noteName);
                }
              }}
            >
              <span className="anjok-marker" aria-hidden="true" />
              <small>{index + 1}</small>
            </button>
          );
        })}
      </div>
      <p className="instrument-note">{props.variant.stringProfile?.material} string profile, anjok markers, separated left/right technique zones.</p>
    </div>
  );
}
